import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Edit = lazy(() => import('./Edit'))
const Bulk = lazy(() => import('./Bulk'))

// Les liens de la grille sont relatifs à l'onglet : ajout, bulk et édition vivent sous « qualifications ».
export const TrainingPilotQualificationsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--pilot-qualifications']}>
    <Route path='qualifications/bulk' element={<Bulk />} />
    <Route path='qualifications/new' element={<Edit />} />
    <Route path='qualifications/:id' element={<Edit />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
